// Unpublished Work © 2024 Deere & Company.

import { useTheme } from "@deere/fuel-react";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

const DealerAccountsNotSet = () => {
  const theme = useTheme();
  const { t } = useTranslation(["common"]);

  return (
    <Box
      data-testid="dealer-accounts-not-set"
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        padding: "80px 40px",
        gap: theme.tokens.FuelSpacing1,
      }}
    >
      <AccountCircleOutlinedIcon
        sx={{
          color: theme.tokens.FuelColorGray400,
        }}
        data-testid="profile-light-icon"
      />
      <Typography
        sx={{
          color: theme.tokens.FuelColorTextTertiary,
          fontWeight: theme.tokens.FuelFontWeightSemibold,
          fontSize: theme.tokens.FuelFontSizeMd,
        }}
      >
        {t("header.selectDealerAccount.noAccountsSelectedYet")}
      </Typography>
      <Typography
        sx={{
          fontSize: theme.tokens.FuelFontSizeSm,
        }}
      >
        {t("header.selectDealerAccount.chooseAccountsFromPreferences")}
      </Typography>
      <Link
        style={{
          marginTop: theme.tokens.FuelSpacing2,
          color: theme.tokens.FuelColorTextLink,
          fontWeight: theme.tokens.FuelFontWeightSemibold,
        }}
        to="/preferences"
      >
        {t("common:preferencesLink")}
      </Link>
    </Box>
  );
};

export default DealerAccountsNotSet;
